
import { getPostList } from '@/api/post';
import { Component, Vue } from 'vue-property-decorator';
import { IPost } from '@/types/post';
import { IBoard, IField } from '@/types/board';
import Pagination from '@/components/Pagination/index.vue';

@Component({
  components: {
    Pagination,
  },
})
export default class extends Vue {
  mounted() {
    this.getPostList();
  }

  private listLoading: boolean = true;

  private listQuery = {
    boardUid: '4360c542-4861-4b23-9a29-215336b67976',
    searchType: 'title',
    searchValue: '',
    businessStatus: true,
    page: 0,
    size: 10,
  };

  private boardList: IBoard[] = [];

  private boardFieldList: IField[] = [];

  private searchFieldList: IField[] = [];

  private searchBoardUid: string = ''; // 검색 완료된 게시판 고유값

  private totalElements: number = 0;

  private postList: IPost[] = [];

  private getPostList() {
    this.listLoading = true;
    getPostList(this.listQuery).then((res) => {
      this.listLoading = false;
      const postList: any = [];
      res.data.content.forEach((post: any) => {
        postList.push({
          ...post,
          showStatus: false,
        });
      });
      this.postList = postList;
      this.totalElements = res.data.totalElements;
      this.setBoard(this.listQuery.boardUid);
    });
  }

  private setBoard(boardUid: string) {
    const boardIndex = this.boardList.findIndex((board: IBoard) => board.uid === boardUid);
    if (boardIndex > -1) {
      const targetBoard: IBoard = this.boardList[boardIndex];
      console.log(targetBoard);
      this.boardFieldList = targetBoard.fieldList.filter((bf: IField, index: number) => index === 0);
      this.listQuery.searchType = 'title';
      if (this.searchBoardUid !== this.listQuery.boardUid) {
        this.searchFieldList = targetBoard.fieldList.filter((bf: IField) => bf.searchState);
      }
    }
  }

  private handleWriteClick(post: IPost) {
    if (post === undefined) {
      this.$router.push({ name: 'one-inquiryWrite', params: { postUid: this.listQuery.boardUid } });
    } else {
      this.$router.push({ name: 'one-inquiryWrite', params: { postUid: post.uid } });
    }
  }

  // private handleClickPost(post: any) {
  //   post.showStatus = !post.showStatus;
  // }
  private handleClickPost(uid: any) {
    this.$router.push({ name: 'one-inquiryDetail', params: { ...uid } });
  }
}
